module.exports = __webpack_public_path__ + "assets/img/thumb-webprofits-2021-video-services-showreel.24c44ffd.jpg";